import { Component, computed, DestroyRef, inject, Input, OnInit, Signal, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { COMMON_NAVIGATION, INTERIOR_DESIGNER_NAVIGATION, NavItem, TRICHOLOGIS_NAVIGATION } from '../navigation';
import { AuthService, ProfessionType } from './auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule, RouterModule, TranslateModule],
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss']
})
export class AppSidebarComponent implements OnInit {
  private translate = inject(TranslateService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private auth = inject(AuthService)

  private userType: Signal<ProfessionType | undefined> = computed(() => this.auth.currentUser()?.profession_type)

  @Input() activeRoute = '';

  /** Identyfikator sekcji (`item.route`) z podmenu; tylko jedna rozwinięta naraz. */
  expandedSectionRoute = signal<string | null>(null);

  navItems: Signal<NavItem[]> = computed(() => {
    let userTypeSpecificNav: NavItem[] = []
    const userType = this.userType();
    switch (userType) {
      case 'Trichology':
        userTypeSpecificNav = TRICHOLOGIS_NAVIGATION;
        break;

      case 'Interior_design':
        userTypeSpecificNav = INTERIOR_DESIGNER_NAVIGATION;
        break;
    }

    return COMMON_NAVIGATION.concat(userTypeSpecificNav).sort((a, b) => a.index - b.index)
  });

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.syncExpandedFromUrl());

    this.syncExpandedFromUrl();
  }

  toggleSubmenu(sectionRoute: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.expandedSectionRoute.update((current) => (current === sectionRoute ? null : sectionRoute));
  }

  private syncExpandedFromUrl(): void {
    const path = this.router.url.split('?')[0];
    for (const item of this.navItems()) {
      if (!item.children?.length) {
        continue;
      }
      const base = item.route.replace(/\/$/, '');
      const matches =
        path === base || path.startsWith(`${base}/`);
      if (matches) {
        this.expandedSectionRoute.set(item.route);
        return;
      }
    }
    this.expandedSectionRoute.set(null);
  }
}
